import React, { useEffect, useRef, useState } from 'react';
import Googlestars from './Googlestars';
import StarRatings from 'react-star-ratings';
import Slider from 'react-slick';
import moment from 'moment';
import PropTypes from 'prop-types';
import Truncate from 'react-truncate';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Button } from 'carbon-components-react';
import { Launch16, ChevronLeft32, ChevronRight32 } from '@carbon/icons-react';
import determineSlidesDisplay from '../utilities/determineSlidesDisplay';
import './Card.scss';

function Card({ width, data, stars, theme, trid }) {
  const customSlider = useRef();
  const [slidesToShowAndScroll, setSlidesToShowAndScroll] = useState();
  const [dotsAppended, setDotsAppended] = useState(false);

  const reviewLink = `https://www.trustradius.com/products/${data.config.products[0].slug}/reviews?rk=ibmcvs20181&utm_campaign=tqw&utm_medium=widget&utm_source=www.trustradius.com&trtid=36d1014e-506a-4f6f-950b-7b22b55ffdc6`;

  const numRows = Math.ceil(data.data.length / slidesToShowAndScroll);
  let starsDisplay;
  if (stars === 'true') {
    starsDisplay = (
      <Googlestars
        product={data.config.products[0].name}
        count={String(data.config.products[0].rating.count)}
        score={String(data.config.products[0].rating.trScore)}
      />
    );
  }

  useEffect(() => {
    setDotsAppended(false);
    setSlidesToShowAndScroll(determineSlidesDisplay(data.data.length, width));
  }, [width]);

  useEffect(() => {
    // ensure text truncation takes effect on first load
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 500);
  }, []);

  const allReviewsBtn = (
    <div>
      <Button
        kind="ghost"
        renderIcon={Launch16}
        href={reviewLink}
        target="_new"
        data-attribute1="TrustRadius-all">
        Read all reviews
      </Button>
    </div>
  );

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: slidesToShowAndScroll,
    slidesToScroll: slidesToShowAndScroll,
    nextArrow: false,
    prevArrow: false,
    dotsClass: `slick-dots slick-dots-${trid} Card-navdiv`,
    appendDots: function appendDotsFunc(dots) {
      return (
        <div>
          <div>{allReviewsBtn}</div>
          <div className="Card-btncontainer">
            {' '}
            <Button
              renderIcon={ChevronLeft32}
              iconDescription="Previous"
              hasIconOnly
              data-attribute1="TrustRadius-arrow"
              onClick={() => customSlider.current.slickPrev()}
            />
            <ul className="Card-numlist body-short-01"> {dots} </ul>
            <span className="Card-numlist body-short-01"> / </span>{' '}
            <ul className="Card-numlist body-short-01">
              <li className="total-pages">{numRows}</li>
            </ul>
            <Button
              renderIcon={ChevronRight32}
              iconDescription="Next"
              hasIconOnly
              data-attribute1="TrustRadius-arrow"
              onClick={() => customSlider.current.slickNext()}
            />
          </div>
        </div>
      );
    },
    customPaging: function customPagingFunc(i) {
      return <span className="page">{i + 1}</span>;
    },
    onReInit: function onReInitFunc() {
      if (document.querySelector(`.slick-dots-${trid}`) !== null) {
        setDotsAppended(true);
      }
    },
  };

  return (
    <div className={`Card Card-${theme}`}>
      {starsDisplay}
      <a
        href={reviewLink}
        className="Card-cardlinks"
        target="_new"
        data-attribute1="TrustRadius-logo">
        <div className="Card-headlink headlink">
          <span>
            What {data.config.products[0].name} customers are saying on
          </span>
          <img
            className="Card-headimage"
            src="https://d30ia583fbtg8i.cloudfront.net/images/trustradius-wordmark-blue-240-40.png"
            alt="TrustRadius logo"></img>
        </div>
      </a>
      <div data-items=".ibm-card" className="Card-gridwise">
        <div>
          <div className="Card-quidproquo cardContainer">
            <Slider
              ref={slider => (customSlider.current = slider)}
              {...settings}>
              {data.data.map(function(review, i) {
                var cardlink = 'https://www.trustradius.com/reviews/';
                var trun = '';
                var parse = require('html-react-parser');
                return (
                  <a
                    key={i}
                    className="Card-cardlinks"
                    href={cardlink + review.quotes[0].review.slug}
                    target="_new"
                    data-attribute1="TrustRadius-card">
                    <div className="Card-cardheight ibm-card">
                      <div className="Card-cardcontent ibm-card__content">
                        <p className="Card-heading heading">
                          <Truncate lines={3} ellipsis={<span>... </span>}>
                            {review.quotes[0].review.heading}
                          </Truncate>
                        </p>
                        <div>
                          <StarRatings
                            rating={review.quotes[0].rating / 2}
                            starRatedColor="#1f71ff"
                            numberOfStars={5}
                            starDimension="12px"
                            starSpacing="1px"
                          />

                          <span className="Card-dateline caption-01">
                            {' '}
                            {moment(
                              review.quotes[0].review.publishedDate,
                            ).format('MMM Do YYYY')}
                          </span>
                        </div>
                        <div className="Card-cardhr ibm-rule" />
                        {review.quotes.map(function(text) {
                          trun += `${text.text}<br/><br/>`;
                          trun += ' ';
                        })}
                        <div className="Card-content content">
                          <Truncate lines={7} ellipsis={<span>... </span>}>
                            {parse(trun)}
                          </Truncate>
                        </div>
                        <div className="Card-byline footer">
                          {review.name.first} {review.name.last}
                          <br></br>
                          {review.position.title}
                          <br></br>
                          {review.company.name}
                          <br></br>
                          {review.company.industry.name} {review.company.size}
                        </div>
                      </div>
                    </div>
                  </a>
                );
              })}
            </Slider>
            {!dotsAppended && (
              <div className="Card-allreviews all-reviews-btn-container">
                {allReviewsBtn}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

Card.propTypes = {
  stars: PropTypes.string,
  data: PropTypes.any,
  width: PropTypes.number,
  theme: PropTypes.string,
  trid: PropTypes.string,
};

export default Card;
